import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthDataService } from '../../../../core/services/data-services/auth-data.service';
import { StorageHelperService } from '../../../../shared/services/storage.helper';
import { SignUpServiceModel } from '../models/sign-up-service.interface';
import { SignUpModel } from '../models/sign-up.interface';

@Injectable({
  providedIn: 'root',
})
export class SignUpService implements SignUpServiceModel {
  constructor(
    private authService: AuthDataService,
    private storage: StorageHelperService,
  ) {}

  public signUp(data: SignUpModel): Observable<void> {
    return this.authService.signUp({
      ...data,
    });
  }
}
